import { messages } from "../../src/resources/strings";
import { APIService } from "../utilities/Constants";
import { apiGet, apiPut } from "./utils/apiUtils";

//API :: Get latest banner
export const getLatestBanner = async (policyNumbers: string) => {
  const response = await apiGet<any>(
    APIService.notificationService,
    `/banner/${policyNumbers}`
  );

  if (response) {
    if (response?.length <= 0) {
      return {
        response: null,
        errorCode: messages.error.noDataFound,
      };
    } else {
      const latest = response?.reduce((a: any, b: any) =>
        a.createdAt > b.createdAt ? a : b
      );
      return {
        response: latest,
        errorCode: messages.error.noError,
      };
    }
  } else {
    return {
      response: null,
      errorCode: messages.error.somthingWrong,
    };
  }
};

//API :: Update notification list
export const updateBanner = async (bannerId: string) => {
  try {
    const params = JSON.stringify({
      isVisible: false,
    });

    const response = await apiPut(
      APIService.notificationService,
      `/banner/${bannerId}`,
      params
    );
    if (response.status === 200) {
      return {
        response: null,
        errorCode: messages.error.noError,
      };
    } else {
      return {
        errorCode: messages.error.somthingWrong,
      };
    }
  } catch (error) {
    return {
      errorCode: messages.error.somthingWrong,
    };
  }
};
